import { __awaiter, __extends, __generator } from "tslib";
import { BaseApi } from '../BaseApi';
import { query as getProductQuery } from '../../graphql/getProduct.graphql';
import { query as getExtendedProductBySlugQuery } from '../../graphql/getExtendedProductBySlug.graphql';
import { query as getExtendedProductByIdQuery } from '../../graphql/getExtendedProductById.graphql';
import { query as getExtendedProductsListQuery } from '../../graphql/getExtendedProductsList.graphql';
import { query as getExtendedProductBySlugWithoutVariantDiscountQuery } from '../../graphql/getExtendedProductBySlugWithoutVariantDiscount.graphql';
import { query as getExtendedProductByIdWithoutVariantDiscountQuery } from '../../graphql/getExtendedProductByIdWithoutVariantDiscount.graphql';
import { query as getExtendedProductsListWithoutVariantDiscountQuery } from '../../graphql/getExtendedProductsListWithoutVariantDiscount.graphql';
import { GraphQLOperations, RemoteSourceTypes } from '../constants';
import { NotFoundError } from '../errors/NotFoundError';
import { SPECS } from '../../constants';
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductsApi.prototype.fetchProductSlug = function (productId) {
        return this.fetch({
            variables: { productId: productId },
            operationName: GraphQLOperations.GetProduct,
            query: getProductQuery,
        }, RemoteSourceTypes.ScalaReadOnly).then(function (response) { return response.data.catalog.product; });
    };
    ProductsApi.prototype.fetchExtendedProductBySlug = function (slug) {
        return __awaiter(this, void 0, void 0, function () {
            var includeProductItemDiscount, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        includeProductItemDiscount = this.siteStore.experiments.enabled(SPECS.AddDiscountsToVariantsItemsQueries);
                        return [4 /*yield*/, this.fetch({
                                variables: { slug: slug },
                                operationName: includeProductItemDiscount
                                    ? GraphQLOperations.GetExtendedProductBySlug
                                    : GraphQLOperations.GetExtendedProductBySlugWithoutVariantDiscount,
                                query: includeProductItemDiscount
                                    ? getExtendedProductBySlugQuery
                                    : getExtendedProductBySlugWithoutVariantDiscountQuery,
                            }, RemoteSourceTypes.ScalaReadOnly)];
                    case 1:
                        response = _a.sent();
                        if (response.data.catalog.product === null) {
                            throw new NotFoundError("cannot find a product with slug: ".concat(slug));
                        }
                        return [2 /*return*/, response.data.catalog.product];
                }
            });
        });
    };
    ProductsApi.prototype.fetchExtendedProductById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var includeProductItemDiscount, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        includeProductItemDiscount = this.siteStore.experiments.enabled(SPECS.AddDiscountsToVariantsItemsQueries);
                        return [4 /*yield*/, this.fetch({
                                variables: { id: id },
                                operationName: includeProductItemDiscount
                                    ? GraphQLOperations.GetExtendedProductById
                                    : GraphQLOperations.GetExtendedProductByIdWithoutVariantDiscount,
                                query: includeProductItemDiscount
                                    ? getExtendedProductByIdQuery
                                    : getExtendedProductByIdWithoutVariantDiscountQuery,
                            }, RemoteSourceTypes.ScalaReadOnly)];
                    case 1:
                        response = _a.sent();
                        if (response.data.catalog.product === null) {
                            throw new NotFoundError("cannot find a product with id: ".concat(id));
                        }
                        return [2 /*return*/, response.data.catalog.product];
                }
            });
        });
    };
    ProductsApi.prototype.fetchDefaultProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            var includeProductItemDiscount, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        includeProductItemDiscount = this.siteStore.experiments.enabled(SPECS.AddDiscountsToVariantsItemsQueries);
                        return [4 /*yield*/, this.fetch({
                                variables: {
                                    limit: 1,
                                    sortField: 'CreationDate',
                                    direction: 'Descending',
                                    onlyVisible: true,
                                },
                                operationName: includeProductItemDiscount
                                    ? GraphQLOperations.GetExtendedProductsList
                                    : GraphQLOperations.GetExtendedProductsListWithoutVariantDiscount,
                                query: includeProductItemDiscount
                                    ? getExtendedProductsListQuery
                                    : getExtendedProductsListWithoutVariantDiscountQuery,
                            }, RemoteSourceTypes.ScalaReadOnly)];
                    case 1:
                        response = _a.sent();
                        if (response.data.catalog.products.list === null) {
                            throw new NotFoundError('no products in store');
                        }
                        return [2 /*return*/, response.data.catalog.products.list[0]];
                }
            });
        });
    };
    return ProductsApi;
}(BaseApi));
export { ProductsApi };
//# sourceMappingURL=ProductsApi.js.map